import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import { Product } from "../../../../../../models/Product";
import { defer } from "../../../../../../utils/script";
import SiteItem from "../SiteItem";

export default class CartItem extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    isView = false,
    hideSelect,
    title,
    note = "",
    details = [],
    onSelect = () => { },
    onChange = () => { }
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("CartItem", {
        "hide-title": !title,
        "hide-note": !note,
      }),
      title: title,
      note: note,
    }, true, defaultLoading);
    this.title = title;
    this.isView = isView;
    this.hideSelect = hideSelect;
    this.onSelect = onSelect;
    this.onChange = onChange;
    this.isLoading = true;
    /** @type {[Product]} */
    this.details = details;
    /**@type {[SiteItem]} */
    this.carts = [];
    this.defaultLoading = defaultLoading;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "CartItem");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.details.length) {
      this.fillData(true);
    }
    this.addEvent();
  }

  fillData(isDetail = false) {
    this.isView ? this.element.addClass("is-view") : this.element.removeClass("is-view");
    this.hideSelect ? this.element.addClass("hide-select") : this.element.removeClass("hide-select");

    if (isDetail) {
      this.carts = [];
      $(".cart-sites", this.element).html("");
      if (this.details.length) {
        let hasUnselect = this.details.filter(item => item.type === Product.TYPE_PRODUCT.UNSELECT.id).length > 0;
        let groupSites = Product.groupProductWithSite(this.details);
        groupSites.forEach(item => {
          this.carts.push(new SiteItem({
            isView: this.isView,
            parent: $(".cart-sites", this.element),
            siteId: item.site.id,
            siteUrl: item.site.domain,
            siteLogo: item.site.siteMeta.logoUrl,
            products: item.products,
            hideSelect: this.hideSelect,
            onSelect: (e) => this.onSelect(e),
            onChange: (product) => {
              typeof this.onChange == "function" && this.onChange(product)
            },
            defaultLoading: this.defaultLoading,
          }))
        });
        this.setSelected(!hasUnselect);
      }
    }
    this.setIsLoading(false);
  }

  /** @param {CardItem} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      let isDetail = false;
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
        if (key === "details") {
          isDetail = true;
        }
      });
      this.fillData(isDetail)
    });
  }

  addEvent() {
    $("input[name=checkall]", this.element).on("change", (e) => {
      this.onChangeSelect(e.target.checked);
      typeof this.onSelect == "function" && this.onSelect(this.element);
    })
  }

  onChangeSelect(isSelect) {
    this.setSelected(isSelect);
    this.carts.forEach(element => {
      element.onChangeSelect(isSelect)
    });
  }

  getSelected() {
    return $("input[name=checkall]", this.element).is(':checked');
  }

  setSelected(isChecked) {
    $("input[name=checkall]", this.element).prop('checked', isChecked);
  }

  getProductsSelected() {
    let result = [0];
    this.carts.forEach(element => {
      result.push(...element.getProductsSelected())
    });
    return result;
  }

  getOtherDelivery() {
    let hasOtherDelivery = false;
    this.details.forEach(item => {
      let location = item.getNoteType(Product.TYPE_NOTES.LOCATION);
      if (location) {
        hasOtherDelivery = location.text;
        return true;
      }
    });
    return hasOtherDelivery;
  }

  getIsLoading() {
    return this.isLoading;
  }

  setIsLoading(loading) {
    this.isLoading = loading;
  }

  setCount(count) {
    $(".items-count", this.element).html(count);
  }
}